import React, { useState, useRef, useLayoutEffect } from 'react';
import styled from 'styled-components';

import IconContainer from './IconContainer';
import CustomChevron from './CustomChevron';
import useWindowSize from '../hooks/useWindowSize';

export default function DrawerIcons(props) {
  const iconsRef = useRef();
  const {
    label,
    apps,
    isClosable = true,
    isLast = false,
    isBorder = true,
    opened = true,
    toggleOpened,
    affiliations
  } = props;
  // handle drawer open height
  const [openHeight, setOpenHeight] = useState('auto');
  const [width] = useWindowSize();
  useLayoutEffect(() => {
    setOpenHeight(iconsRef.current.scrollHeight);
  }, [width]);
  return (
    <Container
      isBorder={isBorder}
      isOpen={opened}
      openHeight={openHeight}
      isLast={isLast}
    >
      <div className='row'>
        <h3>{label}</h3>
        {isClosable ? (
          <button className='chevron-container' onClick={toggleOpened}>
            <CustomChevron rotateTime='.3s' isDown={opened} />
          </button>
        ) : null}
      </div>

      <div className='icon-container-container'>
        <div className='icon-container' ref={iconsRef}>
          <IconContainer icons={apps} affiliations={affiliations}/>
        </div>
      </div>
    </Container>
  );
}

const Container = styled.div`
  /* margin-top: 62px; */
  ${({ isBorder }) => (isBorder ? 'border-top: 1px solid var(--ev-red);' : '')}

  overflow: hidden;
  /* position: relative; */
  .row {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  .chevron-container {
    background: none;
    border: none;
    padding-top: 4px;
    padding-bottom: 4px;
    padding-right: 10px;
    padding-left: 10px;
  }
  h3 {
    font-size: 1.8rem;
    line-height: 1.33;
    letter-spacing: 0.01px;
    font-weight: 500;
    margin-top: 25px;
    margin-bottom: 25px;
  }
  .icon-container {
    padding-top: 63px;
    padding-bottom: 77px;
    overflow: hidden;
  }
  .icon-container-container {
    transition: height 0.26s ease;
    height: ${({ isOpen, openHeight }) => (isOpen ? openHeight : 0)}px;
  }
`;
